<template lang="pug">
.modal-card
  header.modal-card-head
    p.modal-card-title
      b(v-t="'vouchers.create_voucher_title'" v-if="!voucher")
      b(v-t="'vouchers.edit_voucher_title'" v-else)
    div
      a.button.is-white.is-small(@click="$emit('close')")
        span.icon
          i.mdi.mdi-close.mdi-24px
  section.modal-card-body
    
    b-field(:label="$t('vouchers.name_label')" :type="errors.has('name') ? 'is-danger': ''" :message="errors.has('name') ? errors.first('name') : ''" expanded )
      b-input(:placeholder="$t('vouchers.name_placeholder')" ref="nameinput" v-model=" name" name="name" data-vv-as="name" expanded v-validate="'required'")
  
    b-field(:label="$t('vouchers.qty_label')" :type="errors.has('qty') ? 'is-danger': ''" :message="errors.has('qty') ? errors.first('qty') : ''"  )
      b-input(:placeholder="$t('vouchers.qty_placeholder')" v-model.number="qty" name="qty" v-validate="'required|numeric|min_value:1|max_value: 30'" :data-vv-as="$t('vouchers.qty_label')" )
    b-field(:label="$t('vouchers.auto_code_label')")
      b-radio(v-model="autoCode" :native-value="true") {{$t('vouchers.auto_code')}}
      b-radio(v-model="autoCode" :native-value="false") {{$t('vouchers.enter_manual_code')}}
  

      //b-field(:label="$t('vouchers.custom_code_label')"  )
    template(v-if="!autoCode")
      .field(v-if="repeatCodes.length")  
        note.is-outlined(size="small" type='is-danger' ) 
          p {{$t('vouchers.custom_code_not_unique', {codes: repeatCodes.join(', ')})}} 
          p.has-text-weight-bold {{repeatCodes.join(', ')}}

      b-field(v-for="idx in codes.length" :key="idx" :label="$t('vouchers.custom_code_label', {count: idx})" label-position="on-border" :type="errors.has(`code_${idx}`) ? 'is-danger': ''" :message="errors.has(`code_${idx}`) ? errors.first(`code_${idx}`) : ''")
        b-input(v-model="codes[idx - 1]" :name="`code_${idx}`" data-vv-as="custom code" expanded v-validate="'required|alpha_num|voucherCodeAvailable'" :placeholder="$t('vouchers.custom_code_placeholder')")
    b-field(grouped)
      b-field(:label="$t('vouchers.value_label')" :type="errors.has('value') ? 'is-danger': ''" :message="errors.has('value') ? errors.first('value') : ''" expanded )
        b-field
          p.control
            span.button.is-static 
              currency
          b-input(:placeholder="$t('vouchers.value_placeholder')" v-model.number="value" @input="onValueInput" name="value" v-validate="'required|decimal:2|min_value:0'" data-vv-as="value" expanded)
      b-field(:label="$t('vouchers.price_label')" :type="errors.has('price') ? 'is-danger': ''" :message="errors.has('price') ? errors.first('price') : ''" expanded )
        b-field
          p.control
            span.button.is-static 
              currency
          b-input(:placeholder="$t('vouchers.price_placeholder')" v-model.number="price" name="price" v-validate="'required|decimal:2|min_value:0'" data-vv-as="price" expanded)
    
    b-field(:label="$t('vouchers.eligible_label')")
      b-radio(v-model="specificServices" name="specificServices" @input="onEligibilityChange" :native-value="false") {{$tc('vouchers.eligible_all')}}
      b-radio(v-model="specificServices" name="specificServices" :native-value="true") {{$t('vouchers.eligible_specific')}}
    template(v-if="specificServices")
      label.label {{$tc('vouchers.number_of_services',  servicesList.length)}} 
      .mb-3(v-for="(item, idx) in servicesList" style="position: relative;padding-right: 3rem;")
        button.delete(@click="removeService(item)" v-if="servicesList.length > 1")              
        ServiceAutocomplete(v-model="item.service" :autocomplete="false" expanded)

      .field
        button.button.is-success(@click="servicesList.push({service: {}})" type="button") {{$t('vouchers.actions.add_service')}}
    b-field(:message="$t('vouchers.expiration_description')")
      b-field(:label="$t('vouchers.valid_label')" grouped group-multiline)
        b-field( :type="errors.has('validity') ? 'is-danger': ''" :message="errors.has('validity') ? errors.first('validity') : ''")
          b-input(v-model="validity"  v-validate="'required|numeric'" name="validity" :placeholder="$t('vouchers.valid_placeholder')")
        b-field( :type="errors.has('validityUnit') ? 'is-danger': ''" :message="errors.has('validityUnit') ? errors.first('validityUnit') : ''")
          b-select(v-model="validityUnit" v-validate="'required'" name="validityUnit" data-vv-as="unit" )
            option(v-for="value in validityUnits" :value="value") {{$t(`misc.${value}`)}}
    b-field(:label="$t('vouchers.notes_label')")
      b-input(v-model="notes" type="textarea" :placeholder="$t('vouchers.notes_placeholder')")
  footer.modal-card-foot
    .buttons
      action-button(:title="voucher? 'actions.save': 'actions.create'" @click="submit" :loading="loading")
      button.button.is-outlined(type="button" @click="$emit('close')" ) {{$t('actions.close')}}      
</template>
<script>
import {mapState} from 'vuex'
import {isInteger} from 'lodash'
import ServiceAutocomplete from '../services/ServiceAutocomplete'

export default {
  name: 'CreateVoucher',
  components: {
    ServiceAutocomplete
  },
  props: {
    voucher: {type: Object, default: undefined}
  },
  data() {
    return {
      loading: false,
      codes: [],
      autoCode: true,
      qty: 1,
      name: undefined,
      value: undefined,
      price: undefined,
      validity: 3,
      notes: undefined,
      specificServices: false,
      validityUnit: 'months',
      validityUnits: ['days', 'weeks', 'months'],
      servicesList: [{service: {}}]
    }
  },
  computed: {
    ...mapState('company', ['company']),
    customCode: {
      get() {
        return this.code
      },
      set(val) {
        this.code = val
          .trim()
          .toUpperCase()
          .replace(/\s/g, '')
      }
    },
    customCodeRules() {
      return 'required|alpha_num|voucherCodeAvailable'
    },
    repeatCodes() {
      return this.codes.filter((c, idx) => (c || c === 0) && this.codes.indexOf(c) !== idx)
    }
  },
  watch: {
    qty() {
      this.initCodes()
    },
    autoCode() {
      this.initCodes()
    }
  },
  created() {
    if (this.voucher) {
      this.name = this.voucher.name
      this.value = this.voucher.value
      this.price = this.voucher.price
      this.notes = this.voucher.notes
      this.validity = this.voucher.validity
      this.validityUnit = this.voucher.validityUnit
      if (this.voucher.services.length > 0) {
        this.specificServices = true
        this.servicesList = this.voucher.services.map(s => {
          return {service: {serviceId: s.service, optionId: s.option}}
        })
      }

      this.qty = this.voucher.qty
      this.autoCode = !this.voucher.codes.length
      this.codes = [...this.voucher.codes]
    } else {
      this.validity = this.company.vouchers?.defaultValidity || 3
      this.validityUnit = this.company.vouchers?.defaultValidityUnit || 'months'
      this.name = this.company.vouchers?.title || this.$t('vouchers.name_initial_value')
    }
  },
  mounted() {
    this.$refs.nameinput.focus()
  },
  methods: {
    removeService(item) {
      let idx = this.servicesList.indexOf(item)
      this.servicesList.splice(idx, 1)
    },
    onValueInput() {
      this.price = this.value
    },
    initCodes() {
      if (!this.qty || !isInteger(this.qty) || this.qty < 1 || this.qty > 30) {
        return
      }
      if (this.autoCode) {
        this.codes = []
      } else {
        if (this.codes.length > this.qty) {
          this.codes = this.codes.slice(0, this.qty)
        } else {
          this.codes = this.codes.concat(Array.from({length: this.qty - this.codes.length}, () => undefined))
        }
      }
    },
    async submit() {
      if (this.loading) {
        return
      }
      this.loading = true
      const valid = await this.$validator.validateAll()
      if (!valid) {
        this.loading = false
        return
      }
      this.$emit('input', {
        name: this.name,
        codes: this.autoCode ? [] : this.codes,
        autoCode: this.autoCode,
        qty: this.qty,
        value: this.value,
        price: this.price,
        notes: this.notes,
        services: this.servicesList
          .filter(s => s.service && s.service.serviceId)
          .map(s => {
            return {service: s.service.serviceId, option: s.service.optionId}
          }),
        validity: this.validity,
        validityUnit: this.validityUnit
      })

      this.$emit('close')
    },
    onEligibilityChange() {
      if (!this.specificServices) {
        this.servicesList = [{service: {}}]
      }
    }
  }
}
</script>
